import {
    AppStoreButton,
    GooglePlayButton,
} from "../StoreButtons";
import PhoneFrame from "../PhoneFrame";
import { APP_SCREEN_HOME } from "./assets";

const HeroCopy = () => (
    <div className="fade-up">
        <span
            data-testid="hero-label"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-[#C4956A] mb-6"
        >
            <span className="w-6 h-px bg-[#C4956A]" />
            A cozy home for readers
        </span>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.03] tracking-tight text-[#2D2D2D]">
            Grab a bag. Scan the code.{" "}
            <span className="italic text-[#C4956A]">Join the club</span>.
        </h1>
        <p className="mt-7 text-lg md:text-xl text-[#6B655C] max-w-xl leading-relaxed font-sans">
            Your next obsession is sitting in a vending machine.
            Peek inside every bag before you go, tap your card,
            and walk away with a story worth staying up for —
            then scan the code to join a community that reads.
            From $9.99/month.
        </p>

        <div
            id="download"
            data-testid="hero-download-buttons"
            className="mt-10 flex flex-wrap items-center gap-4"
        >
            <AppStoreButton testId="hero-appstore-btn" />
            <GooglePlayButton testId="hero-googleplay-btn" />
        </div>

        <div className="mt-10 flex items-center gap-3 text-sm text-[#6B655C]">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#E5D7C5]">
                <span className="w-2 h-2 rounded-full bg-[#C4956A] animate-pulse" />
                <span className="font-medium text-[#2D2D2D]">
                    Launching soon — be among the first readers
                </span>
            </span>
        </div>
    </div>
);

const HeroPhone = () => (
    <div className="relative flex justify-center md:justify-end">
        <div className="absolute inset-0 -m-8 bg-gradient-to-br from-[#F5E9D7] via-transparent to-[#E86A58]/10 rounded-[3rem] blur-2xl" />
        <div className="relative animate-float">
            <PhoneFrame
                src={APP_SCREEN_HOME}
                alt="BookBlend home screen — Discover Books, Build Your Bag, Journal Time"
                testId="hero-phone-mockup"
            />
        </div>
    </div>
);

export const Hero = () => (
    <section
        id="hero"
        data-testid="hero-section"
        className="relative pt-32 md:pt-36 pb-20 md:pb-24 overflow-hidden paper-bg"
    >
        <div className="absolute -top-24 -left-24 w-80 h-80 rounded-full bg-[#C4956A]/20 blur-3xl pointer-events-none" />
        <div className="absolute top-40 right-0 w-72 h-72 rounded-full bg-[#E86A58]/15 blur-3xl pointer-events-none" />

        <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 grid md:grid-cols-2 gap-14 items-center">
            <HeroCopy />
            <HeroPhone />
        </div>
    </section>
);
